(function () {
  var wrapper = document.querySelector('.nav-item.has-mega');
  if (!wrapper) return;

  var header = document.getElementById('header');
  var trigger = wrapper.querySelector('.mega-trigger');
  var menu = wrapper.querySelector('.mega-menu');
  var scrim = wrapper.querySelector('.mega-scrim');
  var railButtons = wrapper.querySelectorAll('[data-mega-open]');
  var panels = wrapper.querySelectorAll('[data-mega-panel]');

  function positionMenu() {
    var bottom = header.getBoundingClientRect().bottom;
    menu.style.top = bottom + 'px';
    scrim.style.top = bottom + 'px';
  }

  function openMenu() {
    positionMenu();
    wrapper.classList.add('open');
    trigger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    wrapper.classList.remove('open');
    trigger.setAttribute('aria-expanded', 'false');
  }

  function toggleMenu() {
    if (wrapper.classList.contains('open')) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  function showPanel(handle) {
    railButtons.forEach(function (btn) {
      btn.classList.toggle(
        'active',
        btn.getAttribute('data-mega-open') === handle,
      );
    });
    panels.forEach(function (panel) {
      panel.classList.toggle(
        'active',
        panel.getAttribute('data-mega-panel') === handle,
      );
    });
  }

  trigger.addEventListener('click', function (e) {
    e.preventDefault();
    toggleMenu();
  });

  railButtons.forEach(function (btn) {
    btn.addEventListener('mouseenter', function () {
      showPanel(btn.getAttribute('data-mega-open'));
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      showPanel(btn.getAttribute('data-mega-open'));
    });
  });

  document.addEventListener('click', function (e) {
    if (!wrapper.contains(e.target)) closeMenu();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });
  window.addEventListener('resize', closeMenu);
  window.addEventListener(
    'scroll',
    function () {
      if (wrapper.classList.contains('open')) positionMenu();
    },
    { passive: true },
  );
})();
